import { FC } from 'react';
import { FormAddOn } from '../FormAnswer.types';
import { formatCurrency } from '~/lib/CurrencyHelpers';

type AddonAnswerProps = {
    answer: {
        addons?: Array<{
            quantity: number;
            addon: FormAddOn;
        }>;
        price: number;
    };
};
const AddonAnswer: FC<AddonAnswerProps> = ({ answer }) => {
    if (!answer.addons) {
        return <span className="text-gray-500 italic">None</span>;
    }
    return (
        <div>
            {!!answer.addons?.map &&
                answer.addons.map(({ addon, quantity }) => (
                    <div>
                        {addon.name} (
                        {addon.price > 0
                            ? formatCurrency(addon.price) + ' '
                            : ''}
                        x {quantity})
                    </div>
                ))}
            {(answer.addons?.length || answer.addons[0]?.quantity) > 1 && (
                <div className="text-gray-500">
                    Total: {formatCurrency(answer.price || 0)}
                </div>
            )}
        </div>
    );
};
export default AddonAnswer;
